[
  {
    "id": "tannenwald",
    "name": "Tannenwald",
    "concept": ["R41", "BI8", "R42"],
    "placeholder": true,
    "color": "#4f7a52",
    "arrive": "Dunkle Tannen stehen dicht am Ufer, Nebel hängt zwischen den Stämmen, und in den Bäumen leuchten kleine runde Fenster.",
    "enemies": "Sturmwesen aus Treibholz und Wind",
    "enemyWeights": { "treibholzer": 2, "windschnitt": 1.5, "nieselchen": 1.4, "schlammling": 1.2, "hagelchen": 0.6, "dreckschleuder": 0.5, "blitzflitzer": 0.5 },
    "boss": { "escortWeights": { "schlammling": 2, "treibholzer": 1.5, "windschnitt": 1.2 } },
    "gate": { "name": "Durchlass zwischen zwei umgestürzten Tannen", "short": "zwei umgestürzte Tannen", "color": "#6b4a30" },
    "ground": { "tint": null, "alpha": 0 },
    "leaves": true
  },
  {
    "id": "moor",
    "name": "Moor",
    "concept": ["R41", "BI8", "R42"],
    "placeholder": true,
    "color": "#a4553f",
    "arrive": "Das Wasser wird still und braun, Torf und Schilf säumen das Ufer, und über dem Moor tanzen die Irrlichter.",
    "enemies": "Sturmwesen aus Schlamm und Nieselregen",
    "enemyWeights": { "schlammling": 2.4, "dreckschleuder": 2.4, "nieselchen": 1.8, "treibholzer": 0.7, "windschnitt": 0.5, "blitzflitzer": 0.5 },
    "boss": { "escortWeights": { "schlammling": 3, "dreckschleuder": 2 } },
    "gate": { "name": "Durchlass unter einem Bogen aus Wurzeln und Schilf", "short": "ein Bogen aus Wurzeln und Schilf", "color": "#5c4a3a" },
    "ground": { "tint": "#8a5a48", "alpha": 0.42 },
    "leaves": false
  },
  {
    "id": "weinhaenge",
    "name": "Weinhänge",
    "concept": ["R41", "BI8", "R42"],
    "placeholder": true,
    "color": "#c9973a",
    "arrive": "Warme Trockenmauern ziehen sich die Hänge hinauf, die letzten Trauben hängen schwer an den Reben, und die Sonne liegt golden auf dem Wasser.",
    "enemies": "Sturmwesen aus Hagel und Gewitter",
    "enemyWeights": { "hagelchen": 2.2, "prallgraupel": 2.2, "blitzflitzer": 2, "donnergroller": 2, "schlammling": 0.6, "treibholzer": 0.6, "dreckschleuder": 0.5 },
    "boss": { "escortWeights": { "donnergroller": 2.5, "prallgraupel": 2, "hagelchen": 1.5 } },
    "gate": { "name": "Durchlass durch ein Tor in der Trockenmauer", "short": "ein Tor in der Trockenmauer", "color": "#b39a72" },
    "ground": { "tint": "#d9b45f", "alpha": 0.32 },
    "leaves": true
  }
]
